import { Navigate, Outlet, useLocation } from "react-router-dom";

const LOGIN_PATH = "/"; 

export default function ProtectedRoute() {
  const location = useLocation();
  const token = localStorage.getItem("adminToken");

  if (!token) {
    return <Navigate to={LOGIN_PATH} replace state={{ from: location }} />;
  }
  return <Outlet />;
}